import React, { useCallback } from 'react'
import { LoyaltyPointsEarningConfiguration } from './CartReviewTile'
import Group from 'components/utils/Group'
import Counter, { CounterChangeEventHandler } from 'LuxKit/Counter'
import MerchandiseCartReviewTileContent from './MerchandiseCartReviewTileContent'
import noop from 'lib/function/noop'

interface Props {
  brand: string;
  title: string;
  variant: App.MerchandiseOfferVariant;
  variantDetails?: string;
  quantity: number;
  onAddItem?: () => void;
  onRemoveItem?: () => void;
  loyaltyPointsEarningConfiguration?: LoyaltyPointsEarningConfiguration;
}

function MerchandiseCartReviewCondensedTileContent(props: Props) {
  const {
    brand,
    title,
    variant,
    loyaltyPointsEarningConfiguration,
    quantity,
    onAddItem = noop,
    onRemoveItem = noop,
  } = props

  const onQuantityChange = useCallback<CounterChangeEventHandler>((value, _, e) => {
    e.preventDefault()
    if (value > quantity) {
      onAddItem()
    } else {
      onRemoveItem()
    }
  }, [quantity, onAddItem, onRemoveItem])

  return <Group
    direction="horizontal"
    horizontalAlign="space-between"
    fullWidth
    verticalAlign="start"
    gap={12}
  >
    <MerchandiseCartReviewTileContent
      brand={brand}
      title={title}
      variant={variant}
      loyaltyPointsEarningConfiguration={loyaltyPointsEarningConfiguration}
    />
    {!!variant.inventory && <Counter
      size="small"
      value={quantity}
      min={1}
      max={variant.inventory}
      onChange={onQuantityChange}
    />}
  </Group>
}

export default React.memo(MerchandiseCartReviewCondensedTileContent)
